import type { CSSObject } from "type/tss";

/**
 * The refreshed Secondary button's 2px outline (MAX-4419 design kit). A button at another size
 * spreads this and trims its own padding by the extra 1px, as the settings sticky footer does.
 */
export const refreshedOutline = {
	borderWidth: 2,
	"&:hover": { borderWidth: 2 },
} satisfies CSSObject;

export const styles = () => {
	return ({
		// Padding trimmed for the thicker outline, so it keeps the contained button's height.
		root: {
			...refreshedOutline,
			padding: "6px 14px",
		},
	} satisfies Record<string, CSSObject>);
};
